import type { FormControlModelExtended } from './types';
import { FormField } from './FormField';

export function FormFieldContainer({ controlModel }: { controlModel: FormControlModelExtended }) {
	if (!controlModel.formControls || controlModel.formControls.length === 0) {
		return null;
	}
	const children = controlModel.formControls.map((childControlModel, index) => (
		<FormField key={`${childControlModel.name ?? childControlModel.controlType}-${index}`} controlModel={childControlModel} />
	));

	return controlModel.className ? <div className={controlModel.className}>{children}</div> : children;
}
